import * as React from "react";
import { forwardRef } from "react";
const SvgFilterThin = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: 2.25, strokeLinecap: "round", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M3 6H21" }), /* @__PURE__ */ React.createElement("path", { d: "M7 12H17" }), /* @__PURE__ */ React.createElement("path", { d: "M10 18H14" }));
const ForwardRef = forwardRef(SvgFilterThin);
export { ForwardRef as ReactComponent };
